import React from 'react';
import Marketing from '../images/marketing.svg';
import { Link } from 'react-router-dom';
import SubserviceDetailComponent from '../components/SubserviceDetailComponent';
import { FaCloud, FaLock, FaMobileAlt, FaDesktop } from 'react-icons/fa';

const services = [
  {
    icon: <FaCloud />,
    title: 'Social Media Marketing',
    description: 'Drive engagement and brand visibility with targeted social media strategies. Leverage platforms like Facebook, Instagram, and LinkedIn to connect with your audience and grow your online presence.',
  },
  {
    icon: <FaLock />,
    title: 'SEO',
    description: 'Enhance your website’s visibility on search engines with our expert SEO services. Improve your rankings and attract more organic traffic through keyword optimization and on-page strategies.',
  },
  {
    icon: <FaMobileAlt />,
    title: 'SEM',
    description: 'Maximize your reach with Search Engine Marketing. Our SEM strategies include pay-per-click advertising to drive targeted traffic and boost conversions through well-placed ads.',
  },
  {
    icon: <FaDesktop />,
    title: 'Content Creation',
    description: 'Engage your audience with compelling content. From blogs to infographics, our content creation services craft persuasive and relevant material that enhances your brand’s voice.',
  },
  {
    icon: <FaDesktop />,
    title: 'Email Campaigns',
    description: 'Boost customer engagement with targeted email campaigns. Our services include designing, sending, and tracking emails to increase conversions and foster customer loyalty.',
  },
  {
    icon: <FaDesktop />,
    title: 'Graphic Designing',
    description: 'Create stunning visuals with our graphic design services. From logos to marketing materials, our designs help establish your brand’s identity and capture audience attention.',
  },
  {
    icon: <FaDesktop />,
    title: 'Video Editing',
    description: 'Enhance your marketing efforts with professional video editing. Our services produce high-quality videos that effectively communicate your brand’s message and engage viewers.',
  },
  {
    icon: <FaDesktop />,
    title: 'Business E-cards',
    description: 'Modernize your networking with digital business e-cards. Our custom designs provide a professional way to share your contact information and make a lasting impression.',
  },
  {
    icon: <FaDesktop />,
    title: 'Media Handles Creation',
    description: 'Establish a strong online presence with expertly managed media handles. We create and optimize your social profiles to increase brand visibility and engagement.',
  },
  {
    icon: <FaDesktop />,
    title: 'Website Optimization',
    description: 'Improve user experience and performance with our website optimization services. Enhance loading speed, mobile responsiveness, and search engine ranking for better results.',
  },
];

const DigitalMarketing = () => {
  return (
    <div className = "relative">
      <img
        className="h-auto w-full object-cover"
        src={Marketing}
        alt="Marketing Services"
      />

      <div>

      <section className='text-left mt-6'>
      <h1 className="text-center my-6 text-2xl font-semibold">Digital Marketing</h1>
      </section>
     

      <section>
        <SubserviceDetailComponent services={services}/>
        <div className='mb-6'>
        <h2 className="text-xl font-semibold mb-6 mx-6">Get Started with Expert Marketing Services</h2>
        <p className="text-md text-black mb-6 px-12 text-left">
        Maximize efficiency, enhance security, and drive growth with our tailored Marketing Services. Our certified experts provide 24/7 support, proactive monitoring, and strategic Marketing planning to meet your business needs.
        </p>
        
        <Link to="/contact"
        className="inline-block bg-[#13689b] text-white py-3 px-6 rounded-md text-md font-semibold transition-transform transform hover:scale-105">
      Contact Us
      </Link>
        </div>
      </section>

    </div>

    </div>
  )
}

export default DigitalMarketing
